var _g, _rect, _path, _path2, _path3, _path4, _path5, _path6, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCvv = function SvgCvv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 53,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#cvv_svg__filter0_dd_1909_22562)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 5,
    width: 64.051,
    height: 40.29,
    rx: 6,
    fill: "#F3F4F5"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.073,
    y: 35.073,
    width: 9.427,
    height: 6.236,
    rx: 0.802,
    fill: "#CED4D9",
    stroke: "#CED4D9",
    strokeWidth: 0.146
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.841 39.622a1.878 1.878 0 01-1.21.438c-1.031 0-1.867-.822-1.867-1.835 0-1.014.836-1.836 1.867-1.836.462 0 .884.165 1.21.439a1.878 1.878 0 011.21-.439c1.032 0 1.867.822 1.867 1.836 0 1.014-.835 1.835-1.866 1.835-.462 0-.885-.165-1.21-.438z",
    fill: "#CED4D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.841 39.622a1.82 1.82 0 000-2.794 1.878 1.878 0 011.21-.439c1.032 0 1.867.822 1.867 1.836 0 1.014-.835 1.835-1.866 1.835-.462 0-.885-.165-1.21-.438z",
    fill: "#CED4D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.84 39.622a1.82 1.82 0 000-2.794 1.82 1.82 0 000 2.794z",
    fill: "#CED4D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M6 13.781h64.051v5.165H6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.649 22.563h32.026v7.748H10.649z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.707 29h.51v-4.254h-.39c-.102.546-.492.798-1.206.798h-.018v.408h1.104V29zm1.894 0h2.778v-.45h-2.184c.06-.33.282-.594.936-.972.534-.306.882-.576 1.044-.816.162-.234.246-.498.246-.792 0-.75-.546-1.224-1.332-1.224-.834 0-1.374.558-1.374 1.398l.006.108h.51v-.042c0-.582.306-1.014.828-1.014.462 0 .822.324.822.774 0 .24-.066.444-.204.618-.132.168-.45.414-.942.708-.414.246-.708.51-.864.774-.156.264-.24.576-.27.93zm4.744.072c.852 0 1.458-.504 1.458-1.296 0-.54-.264-.918-.768-1.032v-.012c.384-.186.588-.504.588-.852 0-.702-.48-1.134-1.29-1.134-.798 0-1.278.492-1.32 1.374h.51c.012-.582.312-.924.81-.924.45 0 .756.258.756.684 0 .408-.342.696-.846.696-.084 0-.144 0-.192-.006v.432c.102-.012.204-.018.288-.018.564 0 .924.312.924.816 0 .48-.396.822-.918.822-.54 0-.882-.33-.906-.936h-.516v.018c0 .882.576 1.368 1.422 1.368z",
    fill: "#333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50.301,
    y: 22.25,
    width: 17.579,
    height: 8.798,
    rx: 1.75,
    stroke: "#C00",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "cvv_svg__filter0_dd_1909_22562",
    x: 0.109,
    y: 0.582,
    width: 75.833,
    height: 52.072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.473
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.945
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 0 0.439216 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1909_22562"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.473
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.156863 0 0 0 0 0.160784 0 0 0 0 0.239216 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_1909_22562",
    result: "effect2_dropShadow_1909_22562"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_1909_22562",
    result: "shape"
  })))));
};
export default SvgCvv;